import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import MobileNumberPad from '../../util/mobileNumberPad';

const propTypes = {
};

const PasswordResetSuccess = (props) => {

  return (
    <div>
      <i className="fa fa-check-circle-o" aria-hidden="true"></i>
      <span>You'll receive an SMS if we could find the mobile number in our system</span>
    </div>

  );
};


class ResetPasswordForm extends Component {

  constructor(props) {
    super(props);
    this.state = { mobile: '', messageSent: false };
  }

  submit() {
    let passwordResetModel = { mobileNumber: this.state.mobile };
    this.setState({ messageSent: true });
    this.props.onSubmit(passwordResetModel);
  }

  mobileNumberComplete(mobile) {
    this.setState({ mobile: mobile });
  }



  render() {

    let confirmButtonEnabled = this.state.mobile && !this.state.messageSent;
    return (
      <form >
        <h2 className="client-text text-center">Reset PIN</h2>

        <div className="row">
          <div className="col-md-12">
            <div className="card text-center p-l-5 p-r-5">
              {
                this.props.auth.passwordReset ?
                  (<PasswordResetSuccess />) :
                  <div>

                    <p><i className="login-icon fa fa-mobile" /> Mobile Number</p>
                    <MobileNumberPad strength={8} mobileNumberComplete={this.mobileNumberComplete.bind(this)} autoFocus={true} enabled={true} />
                    <div className="well m-t-20">
                      We'll send a message to your mobile with a link to reset your PIN.
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
        {this.props.auth.passwordReset ? null :
          <button disabled={!confirmButtonEnabled} className="btn btn-client btn-lg btn-block" onClick={this.submit.bind(this)} type="button">
            Request PIN Reset
        </button>}
      </form>
    );

  }
}

ResetPasswordForm.propTypes = propTypes;

export default reduxForm({
  form: 'passwordResetForm'
})(ResetPasswordForm);


// WEBPACK FOOTER //
// ./app/auth/components/resetPassword.js